module.exports = __webpack_public_path__ + "img/01_Datos - ICONO.a7c9b307.png";